import React, { Component } from 'react';

import './styles.css';

/**
 * A validation message box.
 *
 * @typedef {Object} Props
 * @prop {String} validationMessage
 * @prop {Object[]} errors
 *
 * @augments {Component<Props>}
 */
export default class FormValidationMessage extends Component {

	render () {
		const { errors, validationMessage } = this.props;

		return (
			<div className='FormValidationMessage' role='alert'>
				<p>{validationMessage}</p>
				<ul>
					{errors.map(({ fieldName, reasons }) => (
						<li key={`validationItem-${fieldName}`}>
							<strong>{fieldName}: </strong> {reasons}.
						</li>
					))}
				</ul>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/FormValidationMessage/FormValidationMessage.js